import { ProjectStage } from 'src/app/shared/model/general/ProjectStage';

/**
 * Contain the name and tooltip of MandatoryMilestone's. All MandatoryTemplate's are elements in MandatoryMilestonesMap.
 */
export class MmsTemplate {
  name: string;
  symbolicName: string;
  tooltip: string;
  isSingleMilestone: boolean;
  isEndOfStage: boolean;
  isLockedAtFid: boolean;
  isSelector: boolean;
  constructionOnly: boolean;
  mandatoryDate: boolean;
  mandatoryEndDate: boolean;
}

export const MandatoryMilestoneList: MmsTemplate[] = [
  {
    name: 'ISA (Initial Screening Approval)',
    symbolicName: 'sel',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'On Site Land Agreements Secured',
    symbolicName: 'las',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'Secure Grid Agreement - End',
    symbolicName: 'sga2',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'Preparation of Permit Application - Start',
    symbolicName: 'ppa1',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: false,
    tooltip: '',
  },
  {
    name: 'Development Design Freeze',
    symbolicName: 'pdf',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'Application for Permit Submitted',
    symbolicName: 'aps',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'Application for Permit Granted',
    symbolicName: 'apg',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'Planning Meeting for G2 FID',
    symbolicName: 'pmg2',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'Route To Market Defined and Secured - End',
    symbolicName: 'rtm2',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'Devex Spend Threshold - Decision Proposal - ≥€5m to <€8m (N-1)',
    symbolicName: 'devex_n1',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: false,
    tooltip: '',
  },
  {
    name: 'Devex Spend Threshold - Gate - ≥€8m (OPEA Board)',
    symbolicName: 'devex_opea',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: false,
    tooltip: '',
  },
  {
    name: 'Devex Spend Threshold - Gate - ≥€100m (AG Board)',
    symbolicName: 'devex_ag',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: false,
    tooltip: '',
  },
  {
    name: 'FID (Final Investment Decision) - Gate - (N-2)',
    symbolicName: 'fid_gn2',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'Wind: <€10m; Solar: <€10m; Storage: <€10m'
  },
  {
    name: 'FID (Final Investment Decision) - Gate - (N-1)',
    symbolicName: 'fid_gn1',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'Wind: ≥€10m to <€40m; Solar: ≥€10m to <€40m; Storage: ≥€10m to <€40m'
  },
  {
    name: 'FID (Final Investment Decision) - Gate - (OPEA Board)',
    symbolicName: 'fid_opea',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'Wind: ≥€40m; Solar: ≥€40m; Storage: ≥€40m'
  },
  {
    name: 'FID (Final Investment Decision) - Gate - (AG Board)',
    symbolicName: 'fid_ag',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: ''
  },
  {
    name: 'Commodity Contract BO - Decision Proposal - <€10m (N-1)',
    symbolicName: 'bab_n1',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: false,
    tooltip: '',
  },
  {
    name: 'Commodity Contract BO - Gate - ≥€10m (OPEA)',
    symbolicName: 'bab_opea',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: false,
    tooltip: '',
  },
  {
    name: 'Commodity Contract BO - Gate - ≥€100m (AG)',
    symbolicName: 'bab_ag',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: true,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: false,
    tooltip: '',
  },
  {
    name: 'Development to Construction Handover',
    symbolicName: 'dch',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'PEP Available',
    symbolicName: 'PEP',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'Date when PMC has shared and discussed Project Execution Plan (PEP) with key members of Project Team to ensure roles and responsibilities are clear and understood.',
  },
  {
    name: 'Construction Kick-Off Conducted',
    symbolicName: 'CKC',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'Date when PMC has formally introduced the Construction Integrated Project Team, described Company expectations and key issues & challenges of the Project. PEP is the leading document for the Construction Kick Off meeting.',
  },
  {
    name: 'Start of Construction',
    symbolicName: 'soc',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'Date when the site is handed over to the contractor. Single milestone date. ' +
      'This milestone date is only added to the Schedule once the Development to Construction handover has been completed.',
  },
  {
    name: 'Site Roads, Hardstands / Preparation works',
    symbolicName: 'srh',
    isSingleMilestone: false,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: `Wind: Date when the physical construction works on the site roads and hardstanding commences (Start Date) and can be used with full bearing capacity (End date). Minor reparation after unit erection are not taken into account.
    PV: Date when the physical construction works on compound, fence gate, roads, laydown areas, site security commences (Start Date) and can be fully used (End Date)
    Date Range. This milestone date is only added to the Schedule once the Development to Construction handover has been completed.`,
  },
  {
    name: 'Build Foundations / Substructure',
    symbolicName: 'bfo',
    isSingleMilestone: false,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: `Wind: Date when the physical construction works on the wind turbine foundations commences (Start Date) and is completed incl. curing and grouting (End Date).
    PV: Date when the physical construction works on the piling commences (Start Date) and is completed incl. substructure (End Date).`,
  },
  {
    name: 'Unit Erection / Mod & Inv Installation',
    symbolicName: 'ter',
    isSingleMilestone: false,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: `Wind: Date when the necessary apparatus (e.g. cranes) are on site and the erection work commences
    (Start Date) until mechanical work is completed (End Date). PV: Date when the first Modules and Inverters are
    being installed on site (Start Date) until all installations are completed (End Date). Date Range. This milestone
    date is only added to the Schedule once the Development to Construction handover has been completed.`,
  },
  {
    name: 'EBoP / Electrical Works',
    symbolicName: 'ebop',
    isSingleMilestone: false,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: `Wind: Date when the contractor commences the work on the electrical infrastructure [Cables & Substation]
    (Start Date) and is completed (End Date). Minor works and testing after energizing the substation are not taken
    into account. PV: Date when the contractor commences work on electrical infrastructure [DC&AC] (Start Date) and is
    completed incl. mechanical completion certificate (End Date). Date Range. This milestone date is only added to the
    Schedule once the Development to Construction handover has been completed`,
  },
  {
    name: 'Grid Connection Available',
    symbolicName: 'ged',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: `This is the date when the grid operator has completed its works and the grid connection is energised so
    that it is available for use by RWE. The 'Grid Agreed' box is used to identify that the 'Grid Energisation' date is
    defined by the agreement with the Grid Operator, by ticking the box it prevents the date being changed.`,
  },
  {
    name: 'First Generation',
    symbolicName: 'fgen',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: `Date when Units are energized and the project generates electricity for the first time.`,
  },
  {
    name: 'Commissioning',
    symbolicName: 'com',
    isSingleMilestone: false,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'Date when the commissioning of the wind turbine work commences (Start Date) and is completed (End Date). ' +
      'Date Range. This milestone date is only added to the Schedule once the Development to Construction handover ' +
      'has been completed.',
  },
  // { deprecated
  //   name: 'Full Operation at Rated Power',
  //   symbolicName: 'forp',
  //   isSingleMilestone: true,
  //   isEndOfStage: false,
  //   isLockedAtFid: true,
  //   isSelector: false,
  //   constructionOnly: true,
  //   mandatoryDate: true,
  //   mandatoryEndDate: true,
  //   tooltip: 'Date when the wind farm can achieve Full Operation with each wind turbine and the grid connection being ' +
  //     'capable of generating at Rated Power. Single milestone date. This milestone date is only added to the Schedule ' +
  //     'once the Development to Construction handover has been completed.',
  // },
  {
    name: 'Commercial Operations Date',
    symbolicName: 'cod',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'The date that the project commences commercial operations where all turbines are able to operate at full power ' +
      '(with no expectation that this would need to change again in the future) as set out in the preferred scenario in the Financial '
  },
  {
    name: 'SCADA Fully Implemented',
    symbolicName: 'SFI',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'Date when SCADA onboarding is completed.',
  },
  {
    name: 'Take Over/PAC',
    symbolicName: 'tov',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: `Wind: Date when the final TO certificate for the turbines was signed by the TSA contractors.
    PV: Date when the the unit is fully completed and accepted by the employer.
    Single milestone date. This milestone date is only added to the schedule once the Development to Construction handover has been completed.`,
  },
  {
    name: 'Project Close-Out',
    symbolicName: 'pco',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: `Date when the List of Open Points (LOP) has been closed and a Lessons Learned session with the IPT was conducted.`,
  },
  {
    name: 'Construction to Operations Handover',
    symbolicName: 'sg4',
    isSingleMilestone: false,
    isEndOfStage: false,
    isLockedAtFid: true,
    isSelector: false,
    constructionOnly: true,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: 'The Construction to Operations Handover is the point where the project formally progresses from the Construction phase to the Operations phase and ‘ownership’ of the project then lies with the Operations Team. Marking the Milestone as "Started" (checkbox) means a Pre-COD Meeting has been held.'
  },
  {
    name: 'End of Operation',
    symbolicName: 'eoo',
    isSingleMilestone: true,
    isEndOfStage: false,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: false,
    mandatoryEndDate: false,
    tooltip: '',
  },
  {
    name: 'End of Stage 1 - Origination',
    symbolicName: 'endOfStage-ORIGINATION',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 2 - Early Development',
    symbolicName: 'endOfStage-EARLY_DEV',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 3 - Mid Development',
    symbolicName: 'endOfStage-MID_DEV',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 4 - Late Development',
    symbolicName: 'endOfStage-LATE_DEV',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 5 - Ready for FID',
    symbolicName: 'endOfStage-READY_FID',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 5a - Post FID (Conditionally)',
    symbolicName: 'endOfStage-POST_FID',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 5b - Post FID (Fully Secured)',
    symbolicName: 'endOfStage-POST_FID_FULL',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 6 - Pre Construction',
    symbolicName: 'endOfStage-PRE_CONSTRUCTION',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 7 - Construction',
    symbolicName: 'endOfStage-CONSTRUCTION',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 8 - Energization / COD',
    symbolicName: 'endOfStage-ENERGIZATION_COD',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
  {
    name: 'End of Stage 9 - Post COD',
    symbolicName: 'endOfStage-POST_COD',
    isSingleMilestone: true,
    isEndOfStage: true,
    isLockedAtFid: false,
    isSelector: false,
    constructionOnly: false,
    mandatoryDate: true,
    mandatoryEndDate: true,
    tooltip: '',
  },
];
export const MandatoryMilestonesMap: Map<string, MmsTemplate> = new Map<string, MmsTemplate>();
for (const mms of MandatoryMilestoneList) {
  MandatoryMilestonesMap.set(mms.symbolicName, mms);
}

export const EndOfStageMilestoneMap: Record<ProjectStage, MmsTemplate> = {
  [ProjectStage.ORIGINATION]: MandatoryMilestonesMap.get('endOfStage-ORIGINATION'),
  [ProjectStage.EARLY_DEV]: MandatoryMilestonesMap.get('endOfStage-EARLY_DEV'),
  [ProjectStage.MID_DEV]: MandatoryMilestonesMap.get('endOfStage-MID_DEV'),
  [ProjectStage.LATE_DEV]: MandatoryMilestonesMap.get('endOfStage-LATE_DEV'),
  [ProjectStage.READY_FID]: MandatoryMilestonesMap.get('endOfStage-READY_FID'),
  [ProjectStage.POST_FID]: MandatoryMilestonesMap.get('endOfStage-POST_FID'),
  [ProjectStage.POST_FID_FULL]: MandatoryMilestonesMap.get('endOfStage-POST_FID_FULL'),
  [ProjectStage.PRE_CONSTRUCTION]: MandatoryMilestonesMap.get('endOfStage-PRE_CONSTRUCTION'),
  [ProjectStage.CONSTRUCTION]: MandatoryMilestonesMap.get('endOfStage-CONSTRUCTION'),
  [ProjectStage.ENERGIZATION_COD]: MandatoryMilestonesMap.get('endOfStage-ENERGIZATION_COD'),
  [ProjectStage.POST_COD]: MandatoryMilestonesMap.get('endOfStage-POST_COD'),
  [ProjectStage.OPERATIONS]: null,
};
